'use es6';

import Raven from 'Raven';
import env from 'enviro';
export default function (chunkName) {
  return function asyncComponentErrorHandler(error) {
    const errorMessage = `Failed to load chunk ${chunkName}`;

    if (!env.deployed()) {
      // eslint-disable-next-line no-console
      console.warn(errorMessage); // eslint-disable-next-line no-console

      console.error(error);
      throw error;
    }

    Raven.captureMessage(errorMessage, {
      extra: {
        chunkName,
        originalError: error
      }
    });
    throw error;
  };
}